module.exports = __webpack_public_path__ + "images/banner0.cdd2.jpg";